export enum UserType {
    PRO = 'pro',
    EXTRA = 'extra',
}

export type TUserType = 'pro' | 'extra';
